<template>
  <div class="new-article">
    <ul class="art-list">

      <li v-for="(item,index) in list" :key="index" @click.stop="details(item.id)">
        <div class="head-img">
          <img :src="item.cusNewsVo.pic" alt>
        </div>
        <div class="content">
          <div class="title">
            <!-- <span>{{item.articleCategory}}</span> -->
            <p class="oneline">{{item.cusNewsVo.title}}</p>
          </div>
          <p class="cancel-collect" @click.stop="getCollect(item.cusNewsVo.id,item.cusNewsVo.userName,item.type)">取消收藏</p>
          <div class="author">
            <p class="name">{{item.userName}}</p>
          </div>
        </div>
      </li>
    </ul>
    <div v-if="newsLoad" class="look-more" @click="newsMore">查看更多</div>
    <p v-if="!newsLoad" class="none-more">没有更多了</p>
  </div>
</template>
<script>
import { log } from 'util';
export default {
  //   name: "App",
  data() {
    return {
      curPage:1,
      newsLoad:true,
      list:[]
    };
  },
  methods:{
    collectList(){
        //收藏
      this.$http
        .get("/api/core/011-myShouCangList", {
          params: {
            token: this.$store.state.userInfo.token,
            type: 1,
            pageNo: this.curPage
          }
        })
        .then(res => {
          console.log(res, "收藏列表");
          if (res.status == 200 && res.data.code == 0) {
			  if(this.curPage==1){
				  this.list = res.data.rows
			  }else{
				  this.list = this.list.concat(res.data.rows);
			  }
            if (res.data.rows.length<=0) {
              this.newsLoad = false;
            }
            this.curPage++;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    newsMore(){
      this.collectList()
    },
    details(id) {
      //图文详情
      this.$router.push({ path: "/ghDetails", query: { id: id, type: 1 } });
    },
    //收藏
    getCollect(id,userName,type) {
      // alert(this.$store.state.userInfo.token + '---' + id + '---' + 1 + '---'+userName)
      this.$http
        .get("/api/core/004-userShouCangPc", {
        // .get("/api/core/004-userShouCang", {
          params: {
            token: this.$store.state.userInfo.token,
			type: type,
            thirdId: id,
            // thirdName: userName
          }
        })
        .then(res => {
          console.log(res, "收藏");
          if (res.status == 200 && res.data.code == 0) {
            this.curPage = 1
            this.collectList()
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.collectList();
  },
};
</script>
<style scoped>
.new-article {
  margin-top: 20px;
}
.new-article .art-list li .content .author .name {
  padding-left: 0px;
  font-size: 14px;
}
.new-article .art-list > li:hover {
  box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.15);
}
.new-article .art-list>li .content .title p{float:none;}
</style>